import { faker } from '@faker-js/faker'

/**
 *
 */
export default function mockOrganization({ override = {} } = {}) {
  const organization = {
    id: faker.string.uuid(),
    name: `buffer-${faker.number.int()}`,
    canEdit: true,
    role: 'admin',
    createdAt: faker.date.past({ years: 2 }),
    isOneBufferOrganization: false,
    billing: {
      canAccessAnalytics: true,
      canAccessEngagement: true,
      canAccessPublishing: true,
      paymentDetails: {
        hasPaymentDetails: false,
      },
      billingRedirectUrl: 'http://buffer.com',
    },
  }

  return {
    ...organization,
    ...override,
  }
}
